import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer, Button, Spin, Popconfirm,
} from 'antd';
import { X, CheckCircle } from '@phosphor-icons/react';

const PendingApprovalsDrawer = ({
  visible,
  onClose,
  partners,
  loading,
  actionLoading,
  onApprove,
  onReject,
}) => {
  const formatDate = (dateString) => new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <Drawer
      title="Partner Approvals"
      placement="right"
      onClose={onClose}
      visible={visible}
      width={400}
      mask
      maskClosable
      maskStyle={{ backgroundColor: 'transparent' }}
      closable={false}
      bodyStyle={{ padding: 0 }}
      className="pending-approvals__drawer"
      extra={
        <Button type="text" onClick={onClose} icon={<X size={16} />} />
      }
    >
      <div className="pending-approvals__description">
        External partners who signed up via invitation are listed here for review.
        Approve to grant portal access, or reject to deny.
      </div>
      {/* eslint-disable-next-line no-nested-ternary */}
      {loading && partners.length === 0 ? (
        <div className="pending-approvals__loading">
          <Spin />
        </div>
      ) : partners.length === 0 ? (
        <div className="pending-approvals__empty">
          <CheckCircle size={40} weight="light" />
          <p>No pending approvals</p>
        </div>
      ) : (
        <div className="pending-approvals__list">
          {partners.map((partner) => (
            <div key={partner.id} className="pending-approvals__card">
              <div className="pending-approvals__info">
                <span className="pending-approvals__name">{partner.name}</span>
                <span className="pending-approvals__email">{partner.email}</span>
                {partner.company_name && (
                  <span className="pending-approvals__company">{partner.company_name}</span>
                )}
                {partner.partner_organization && (
                  <span className="pending-approvals__company">{partner.partner_organization}</span>
                )}
                <span className="pending-approvals__date">
                  {'Signed up '}
                  {formatDate(partner.created_at)}
                </span>
              </div>
              <div className="pending-approvals__actions">
                <Button
                  type="primary"
                  size="small"
                  loading={actionLoading[`${partner.id}_approve`]}
                  disabled={actionLoading[`${partner.id}_reject`]}
                  onClick={() => onApprove(partner.id)}
                >
                  Approve
                </Button>
                <Popconfirm
                  title="Reject this partner?"
                  description="They will be removed and won't have portal access."
                  onConfirm={() => onReject(partner.id)}
                  okText="Reject"
                  okType="danger"
                >
                  <Button
                    type="text"
                    danger
                    size="small"
                    loading={actionLoading[`${partner.id}_reject`]}
                    disabled={actionLoading[`${partner.id}_approve`]}
                  >
                    Reject
                  </Button>
                </Popconfirm>
              </div>
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
};

PendingApprovalsDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  partners: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  actionLoading: PropTypes.object.isRequired,
  onApprove: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
};

export default PendingApprovalsDrawer;
